import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { SPACING_SIZES } from './commons';

export const menuItemTheme = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        fontSize: 14,
        padding: `${SPACING_SIZES.s} ${SPACING_SIZES.ml}`,
        '&:hover': {
          backgroundColor: tokens.stateOnSurfaceHoverStateLayerColor
        },
        '&.Mui-selected': {
          backgroundColor: tokens.colorSecondaryContainer
        },
        '&.MuiButtonBase-root': {
          minHeight: 36
        },
        '&.MuiButtonBase-root.Mui-disabled': {
          opacity: 1,
          '.MuiTypography-root, [data-icon-name]': {
            color: tokens.stateOnSurfaceDisabledContentStateLayerColor,
            fill: tokens.stateOnSurfaceDisabledContentStateLayerColor
          }
        },
        '.MuiListItemText-secondary': {
          color: tokens.paletteNeutral30 // @migrate to in next version of tokens - color/Licorice 500
        },
        '&.dangerous-action': {
          '.MuiTypography-root': {
            color: tokens.colorAlert
          },
          '[data-icon-name]': {
            color: tokens.colorAlert,
            fill: tokens.colorAlert
          }
        }
      }
    }
  }
} satisfies Components;
